import { Component } from '@angular/core';
import { ModalComponent } from '../../../lib/services/modal.service';
import { DownloadAppService } from '../../../lib/services/download-app.service';

@Component({
  selector: 'mj-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss'],
})
export class DownloadAppComponent extends ModalComponent {
  constructor(private downloadAppService: DownloadAppService) {
    super();
  }

  downloadChrome() {
    window.open('https://www.google.com/chrome/', '_blank');
  }

  downloadMojob() {
    const userNavigator = window.navigator.userAgent;
    let userOS = 'win';

    if (userNavigator.indexOf('Mac') !== -1) {
      userOS = 'mac';
    }
    this.downloadAppService.getLatestVersion(userOS);
  }

  onSkip() {
    localStorage.setItem('download-skipped', 'true');
    this.resolve.next(null);
  }
}
